<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      股东权利分析
    </div>
    <div class="paiming2">
      <div class="ms">
        股东权利分析大连总体得分95分,处于对标城市的中上水平, 排名第2位;对标城市中股东权利分析得分最低为上海合计87分,相差8分
      </div>
      <div class="paiming3">
        <div class="head">
          <div class="item1">排名</div>
          <div class="item2">城市</div>
          <div class="item3">得分</div>
        </div>
        <div class="body">
          <div class="bodyitem" v-for="(item,index) in list" :key="index">
            <div class="item1">{{ index + 1 }}</div>
            <div class="item2">{{ item.title }}</div>
            <div class="item3">{{ item.fenshu }}分</div>
          </div>
        </div>
      </div>
      <div class="paiming2x">
        <div id="huodexindai3" :style="{width: '640px', height: '420px'}"></div>
      </div>
      <div class="gudong">股东权利得分</div>

    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: "paiming",
  data: function () {
    return {
      list: [{
        title: '上海',
        fenshu: 90
      }, {
        title: '大连',
        fenshu: 80
      }, {
        title: '北京',
        fenshu: 80
      }, {
        title: '深圳',
        fenshu: 80
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('huodexindai3'))
      // 绘制图表
      myChart.setOption({
        yAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          data: ['上海', '北京', '深圳', '大连']
        },
        xAxis: {
          show: true,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false //小横线
          },
          axisLabel: {
            show: false,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
        },
        grid: {
          top: '40',
          right: '50',
          left: '80',
          bottom: '40' //图表尺寸大小
        },
        animationDuration: 9000,
        series: [{
          /* data: [120, 200, 150, 80, 70, 110, 130], */
          type: 'bar',
          barWidth: '40px',
          label: {
            show: true,
            position: 'right',
            fontSize: 16,
            color: '#fff'
          },
          itemStyle: {
            normal: {
              label: {
                formatter: p => {
                  return p.value + '分';
                },
                show: true,//是否显示
                position: 'right',//显示位置
                textStyle: { //文字样式
                  color: 'rgba(236, 239, 249, 1)',
                  fontSize: 30
                }
              },
              color: (params) => {
                let colors = ['rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(62, 190, 225, 1)', 'rgba(237, 142, 92, 1)']
                return colors[params.dataIndex]
              }, //每个数据的颜色
            },
          },
          data: [
            {
              value: 90
            },
            {
              value: 80
            },
            {
              value: 50
            },
            {
              value: 40
            }
          ]
        }]
      });
    }
  },
  mounted() {
    this.drawLine()
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}

.paiming2 {
  width: 100%;
  height: 948px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;

  .head {
    width: 674px;
    height: 61px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 674px;
  margin: auto;
}

.bodyitem {
  height: 61px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.ms {
  margin-left: 24px;
  margin-right: 24px;
  height: 95px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
}

.chengben2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .chengben3 {
    margin-left: -60px;
  }
}

.paiming2x {
  @include flex_center_center();
}

.gudong {
  text-align: right;
  margin-right: 70px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #39F9FF;
  margin-top: 20px;
}
</style>
